module.exports = __webpack_public_path__ + "img/HSBC-small-logo-no-tagline_C.a5ccec40.jpg";